
import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { Match } from '@/views/interfaces/entities.ts';
import CountDown from './WatchTournament/CountDown.vue';
import TournamentBrackets from './Main/TournamentBrackets.vue';
import MatchCard from './WatchTournament/MatchCard.vue';


export default defineComponent({
  name: 'watch-tournament',
  components: {
    MatchCard,
    CountDown,
    TournamentBrackets,
  },
  data() {
    return {
      loaded: false,
      socket: null as WebSocket | null,
      lastEvent: null,
      emptyMatch: <Match>{
        posLeft: {},
        posRight: {},
        disabled: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      tournament: 'tournament/getTournament',
      match: 'tournament/getMatch',
    }),
  },
  watch: {
    lastEvent: {
      handler(event) {
        console.log(`watcher lastEvent: ${JSON.stringify(event)}`);
        if (!event) return

        if (event.event_type === "score") {
          this.vote(event.position_bracket_id);
        }

        if (event.event_type === "end") {
          this.resetMatch();
          console.log("match ended");
        }
        console.log({eventType: event.event_type});
      },
    },
  },
  async created() {
    this.resetMatch();
    this.resetTournament();
  },
  async mounted() {
    try {
      await this.load(this.$route.params.id);

      // 🔌 OPEN WEBSOCKET
      this.socket = new WebSocket(
        `ws://localhost:3000/ws/tournament/${this.$route.params.id}/`
      );

      this.socket.onmessage = (event) => {
        console.log(`alo event: ${JSON.stringify(event)}`);
        this.lastEvent = JSON.parse(event.data);
      };

      this.socket.onopen = () => {
        console.log("WS connected");
      };

      this.socket.onerror = (err) => {
        console.error("WS error", err);
      };

      this.socket.onclose = () => {
        console.log("WS closed");
      };


      this.loaded = true;
      this.incrementView();
    } catch (err) {
      console.error(`ooops ${err}`);
    }
  },
  beforeUnmount() {
  if (this.socket) {
    this.socket.close();
    this.socket = null;
  }
},
  methods: {
    ...mapMutations({
      setTournament: 'tournament/SET_TOURNAMENT',
      resetMatch: 'tournament/RESET_MATCH',
      resetTournament: 'tournament/RESET_TOURNAMENT',
      vote: 'tournament/VOTE',
    }),
    ...mapActions({
      save: 'tournament/save',
      load: 'tournament/get',
      incrementView: 'tournament/incrementView',
    }),
  },
});
